module.exports = __webpack_public_path__ + "gh.3895c0990be774f2f745.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gh.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gh.svg
// module chunks = styles